import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HEADERMENU_PATH } from '../routes/RoutesURL';
import HSButton from './common/Button';

type Props = {
    notShowBtn?: boolean;
};

const NoMatch: React.FC<Props> = ({ notShowBtn }) => {
    const navigate = useNavigate();

    const redirectToLogin = () => {
        navigate(HEADERMENU_PATH.login);
    };

    return (
        <div className="flex justify-center items-center h-full flex-col" id="notFound">
            <label className="SourceSansPro-Bold text-7xl">404</label>
            <p className="SourceSansPro-SemiBold text-2xl">Page not found</p>
            {!notShowBtn && <HSButton title="Redirect To Login" onClick={redirectToLogin} className="mt-5" />}
        </div>
    );
};

export default NoMatch;
